<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="true"
      title="작업환경측정 결과"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', placeholder: '입력', width: '50px' },
        { id: 'input2', title: '부서명', type: 'text', placeholder: '입력' },
        { id: 'input3', title: '공정명', type: 'text', placeholder: '입력' },
        { id: 'input4', title: '유해인자', type: 'text', placeholder: '입력' },
        { id: 'input5', title: '측정치', type: 'text', placeholder: '입력' },
        { id: 'input6', title: '노출기준', type: 'text', placeholder: '입력' },
        { id: 'input7', title: '노출기준 초과여부', type: 'select', selectData: ['초과', '미만'], placeholder: '선택'},
      ]"
      v-model="form.inputCList"
    >
      <template #customSubTitle>
        <div class="writeGridContainer mb-3">
          <div>
            <div>측정일</div>
            <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
            <date-selector v-else v-model="form.inputA_4" :readonly="board.readonly" />
          </div>
          <div>
            <div>측정 결과</div>
            <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
            <div v-else>
              <vs-radio v-model="form.inputA_7" :disabled="board.readonly" vs-value="적합" vs-name="측정결과" class="mr-4">적합</vs-radio>
              <vs-radio v-model="form.inputA_7" :disabled="board.readonly" vs-value="부적합" vs-name="측정결과" class="mr-4">부적합</vs-radio>
            </div>
          </div>
        </div>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    DisasterClassSelector,
    DateSelector,
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: [],
        };

        value.summary["안전보건점검_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["안전보건점검_점검표"].push({
          ["[공통]안전 순회점검표(현장)"]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  methods: {
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_4: "",
        inputA_7: "",

        inputCList: [],
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
